var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartphoneLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_776_2871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.16659 2.66634V13.333H11.8333V2.66634H5.16659ZM4.49992 1.33301H12.4999C12.6767 1.33301 12.8463 1.40325 12.9713 1.52827C13.0963 1.65329 13.1666 1.82286 13.1666 1.99967V13.9997C13.1666 14.1765 13.0963 14.3461 12.9713 14.4711C12.8463 14.5961 12.6767 14.6663 12.4999 14.6663H4.49992C4.32311 14.6663 4.15354 14.5961 4.02851 14.4711C3.90349 14.3461 3.83325 14.1765 3.83325 13.9997V1.99967C3.83325 1.82286 3.90349 1.65329 4.02851 1.52827C4.15354 1.40325 4.32311 1.33301 4.49992 1.33301ZM8.49992 11.333C8.67673 11.333 8.8463 11.4032 8.97132 11.5283C9.09635 11.6533 9.16659 11.8229 9.16659 11.9997C9.16659 12.1765 9.09635 12.3461 8.97132 12.4711C8.8463 12.5961 8.67673 12.6663 8.49992 12.6663C8.32311 12.6663 8.15354 12.5961 8.02851 12.4711C7.90349 12.3461 7.83325 12.1765 7.83325 11.9997C7.83325 11.8229 7.90349 11.6533 8.02851 11.5283C8.15354 11.4032 8.32311 11.333 8.49992 11.333Z",
    fill: "#333030"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_776_2871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphoneLine);
export default __webpack_public_path__ + "static/media/smartphone-line.0c0c97145d3c40003513b97fc77b19f5.svg";
export { ForwardRef as ReactComponent };